
<template>
  <div class="main">
    <div class="titlefont">
      <div class="titleAnimation">
        <div class="title">{{ suitableStudents.title }}</div>
        <div class="desc">
          {{ suitableStudents.about }}
        </div>
      </div>
    </div>
    <div class="conMain">
      <div class="con">
        <ul class="sixItems">
          <li
            class="item itemA"
            :class="{
              itemA: index == 0,
              itemB: index == 1,
              itemC: index == 2,
              itemD: index == 3,
            }"
            v-for="(item, index) in list"
            :key="index"
          >
            <span class="topL"></span>
            <span class="topR"></span>
            <span class="bottomL"></span>
            <span class="bottomR"></span>
            <p><img :src="item.url" /></p>
            <p class="tit">{{ item.title }}</p>
            <p class="text">{{ item.description }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    suitableStudents: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      list: [
        {
          url: require("../img/yingjie.jpg"),
          title: "应届毕业生",
          description:
            "缺乏工作经验和技能，期望通过学习全链路设计跻身IT行业的人员",
        },
        {
          url: require("../img/jichu.jpg"),
          title: "0基础转行人员",
          description: "设计课程简单、实用、有趣比学编程容易",
        },
        {
          url: require("../img/xinshiwu.jpg"),
          title: "喜欢新事物",
          description: "喜欢接触新兴事物，对互联网行业充满好奇，有探索心",
        },
        {
          url: require("../img/qita.jpg"),
          title: "其它设计转行",
          description:
            "之前从事其它设计行业，想转行含金量高的全链路设计",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>

